export interface DocNavItem {
  title: string
  slug: string
}

export interface DocNavGroup {
  title: string
  items: Array<DocNavItem>
}

export interface DocNavSection {
  title: string
  groups: Array<DocNavGroup>
}

export const docsNavigation: Array<DocNavSection> = [
  {
    title: 'Guide',
    groups: [
      {
        title: 'Getting Started',
        items: [
          { title: 'Introduction', slug: 'introduction' },
          { title: 'Quickstart', slug: 'quickstart' },
        ],
      },
      {
        title: 'Models',
        items: [
          { title: 'Supported Models', slug: 'models/supported-models' },
          { title: 'Provider Tiers', slug: 'models/provider-tiers' },
        ],
      },
      {
        title: 'Billing & Balance',
        items: [
          { title: 'Balance & Credits', slug: 'billing/balance' },
          { title: 'Model Pricing', slug: 'billing/model-pricing' },
          { title: 'Wallet & Credits', slug: 'billing/credits' },
        ],
      },
      {
        title: 'Dashboard',
        items: [
          { title: 'Overview', slug: 'dashboard/overview' },
          { title: 'API Keys', slug: 'dashboard/api-keys' },
          { title: 'Analytics', slug: 'dashboard/analytics' },
          { title: 'Billing & Usage', slug: 'dashboard/billing-usage' },
          { title: 'Agents & Model Stacks', slug: 'dashboard/agents' },
          { title: 'Browse Models', slug: 'dashboard/models' },
          { title: 'Referral Program', slug: 'dashboard/referral' },
          { title: 'Settings', slug: 'dashboard/settings' },
          { title: 'Usage & Logs', slug: 'dashboard/usage' },
        ],
      },
      {
        title: 'SDKs',
        items: [
          { title: 'OpenAI SDK', slug: 'sdks/openai-sdk' },
          { title: 'Anthropic SDK', slug: 'sdks/anthropic-sdk' },
          { title: 'cURL', slug: 'sdks/curl' },
        ],
      },
      {
        title: 'MCP Server',
        items: [
          { title: 'Overview', slug: 'mcp/overview' },
          { title: 'Tools Reference', slug: 'mcp/tools' },
        ],
      },
      {
        title: 'IDE & CLI Integrations',
        items: [
          { title: 'Overview', slug: 'integrations/overview' },
          { title: 'Cursor', slug: 'integrations/cursor' },
          { title: 'Continue', slug: 'integrations/continue' },
          { title: 'Cline', slug: 'integrations/cline' },
          { title: 'Roo Code', slug: 'integrations/roo-code' },
          { title: 'Aider', slug: 'integrations/aider' },
          { title: 'Zed', slug: 'integrations/zed' },
          { title: 'OpenCode', slug: 'integrations/opencode' },
          { title: 'Codex CLI', slug: 'integrations/codex' },
          { title: 'Windsurf', slug: 'integrations/windsurf' },
          { title: 'Amp Code', slug: 'integrations/amp-code' },
          { title: 'Claude Code', slug: 'integrations/claude-code' },
          { title: 'Gemini CLI', slug: 'integrations/gemini-cli' },
          { title: 'Droids', slug: 'integrations/droids' },
        ],
      },
    ],
  },
  {
    title: 'Chat API',
    groups: [
      {
        title: '',
        items: [
          { title: 'Overview', slug: 'api-reference/overview' },
          { title: 'Authentication', slug: 'api-reference/authentication' },
          { title: 'Errors', slug: 'api-reference/errors' },
          { title: 'Chat Completions', slug: 'api-reference/chat-completions' },
          { title: 'Messages (Anthropic)', slug: 'api-reference/anthropic-messages' },
          { title: 'Models', slug: 'api-reference/models' },
        ],
      },
    ],
  },
  {
    title: 'Generations API',
    groups: [
      {
        title: '',
        items: [
          { title: 'Overview', slug: 'api-reference/generations-overview' },
          { title: 'Errors', slug: 'api-reference/generations-errors' },
          { title: 'Endpoints', slug: 'api-reference/generations' },
          { title: 'Model Catalog', slug: 'api-reference/generation-models' },
          { title: 'Generation Types', slug: 'api-reference/generation-types' },
          { title: 'Parameters', slug: 'api-reference/generation-parameters' },
        ],
      },
    ],
  },
]

export function findNavItem(slug: string): {
  item: DocNavItem
  group: DocNavGroup
  section: DocNavSection
} | null {
  for (const section of docsNavigation) {
    for (const group of section.groups) {
      for (const item of group.items) {
        if (item.slug === slug) return { item, group, section }
      }
    }
  }
  return null
}

export function getAdjacentItems(slug: string): {
  prev: DocNavItem | null
  next: DocNavItem | null
} {
  const allItems = docsNavigation.flatMap((s) =>
    s.groups.flatMap((g) => g.items),
  )
  const idx = allItems.findIndex((i) => i.slug === slug)
  return {
    prev: idx > 0 ? allItems[idx - 1] : null,
    next: idx < allItems.length - 1 ? allItems[idx + 1] : null,
  }
}
